'use client';

import Link from 'next/link';
import { FaChevronRight } from 'react-icons/fa';

const RegisterButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Link
        href="/schedules"
        className={`inline-flex items-center gap-2 bg-brand-500 hover:bg-brand-600 text-white font-semibold px-5 py-3 rounded-xl shadow-xl transition-all duration-300 hover:scale-105 focus:ring-2 focus:ring-brand-300`}
      >
        <span className="text-lg">Бүртгүүлэх</span>
        <FaChevronRight className="text-white" />
      </Link>
    </div>
  );
};

export default RegisterButton;
